import { useEffect, useRef } from 'react';
import { useIsVisible } from 'react-is-visible';

export const ScrollIntoView = ({ onScrollIntoView }) => {
  const nodeRef = useRef();
  const isVisible = useIsVisible(nodeRef);

  useEffect(() => {
    isVisible && onScrollIntoView();
  }, [isVisible, onScrollIntoView]);

  return <div ref={nodeRef} />;
};
